import React from 'react';
import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor';
import { useTranslation } from 'react-i18next';
import './index.css';

function IndexCountUp() {
  const { t } = useTranslation();
  const endType = [
    {key: 0, end: 60, title: t('CountUP.title1'), suffix: t('CountUP.suffix1'), info1: t('CountUP.infoa1'), info2: t('CountUP.infob1'), desInfo1: t('CountUP.desInfoa1'), desInfo2: t('CountUP.desInfob1'), desInfo3: t('CountUP.desInfoc1')},
    {key: 1,end: 90, title: t('CountUP.title1'), suffix: t('CountUP.suffix1'), info1: t('CountUP.infoa2'), info2: t('CountUP.infob2'), desInfo1: t('CountUP.desInfoa2'), desInfo2: t('CountUP.desInfob2'), desInfo3: t('CountUP.desInfoc2')},
    {key: 2,end: 80, title: t('CountUP.title2'), suffix: t('CountUP.suffix2'), info1: t('CountUP.infoa3'), info2: t('CountUP.infob3'), desInfo1: t('CountUP.desInfoa3'), desInfo2: t('CountUP.desInfob3'), desInfo3: t('CountUP.desInfoc3')},
    {key: 3,end: 25, title: t('CountUP.title2'), suffix: t('CountUP.suffix2'), info1: t('CountUP.infoa4'), info2: t('CountUP.infob4'), desInfo1: t('CountUP.desInfoa4'), desInfo2: t('CountUP.desInfob4'), desInfo3: t('CountUP.desInfoc4')}
  ]

  return(
  <div className="count">
    {endType.map(({key, end, title, suffix, info1, info2, desInfo1, desInfo2, desInfo3}) => <CountUp
      start={0}
      end={end}
      duration={2.75}
      separator=" "
      decimals={0}
      redraw={true}
      key={key}
    >
      {({ countUpRef, start }) => (
        <VisibilitySensor onChange={start}>
          <div>
           <p>{title}</p>
           <div className="countBox">
              <div className="info">
                <p>{info1}</p>
                <p>{info2}</p>
              </div>
              <span ref={countUpRef} />
              <div className="suffix">{suffix}</div>
           <div className="desInfo">
               <p>{desInfo1}</p>
               <p>{desInfo2}</p>
               <p>{desInfo3}</p>
           </div>
           </div>
          </div>
        </VisibilitySensor>
      )}
    </CountUp>)}
  </div>
  )
}

export default IndexCountUp
